export const WORKSTATION_FOCUS = 'workstation';
export const WORKSTATION_CARD_ID = 'workspace-workstation';

export function workspaceWorkstationHref(workspaceId: string): string {
  return `/workspaces/${encodeURIComponent(workspaceId)}?tab=overview&focus=${WORKSTATION_FOCUS}`;
}
